export const filterProps = (props, filterFn) => Object.entries(props).filter(([key]) => filterFn(key)).reduce((result, [key, value]) => ({
  ...result,
  [key]: value
}), {});
export const modifyProps = (props, modifyFn) => Object.keys(props).reduce((acc, key) => ({
  ...acc,
  [key]: modifyFn(props[key])
}), {});
export const splitProps = (props, keys) => {
  const includedKeys = filterProps(props, key => keys.includes(key));
  const excludedKeys = filterProps(props, key => !keys.includes(key));
  return [includedKeys, excludedKeys];
};